import angular from 'angular';

class principalExportConfigCtrl {
    /* @ngInject */
    constructor($state, PrincipalSvc, $translate, CONF, logger) {
        this.$state = $state;
        this.PrincipalSvc = PrincipalSvc;
        this.$translate = $translate;
        this.CONF = CONF;
        this.logger = logger;
    }

    $onInit() {
        this.exportPortalCustomization = false;

        this.modulesToExport = ['PRINCIPAL'];

        this.title = 'principal.' + this.type + '.result.title';

        this.displayForm = false;
        this.displayLoad = false;
        this.displayResult = false;

        this.manageDisplay('form');
    }

    backList() {
        this.$state.go('do', { tabName: 'principal' });
    }

    addModuleToExport(checked, module) {
        if (checked) {
            if (this.modulesToExport.indexOf(module) === -1) {
                this.modulesToExport.push(module);
            }
        } else {
            var index = this.modulesToExport.indexOf(module);
            this.modulesToExport.splice(index, 1);
        }
    }

    exportConfDo() {
        this.manageDisplay('load');

        this.PrincipalSvc.exportConfDo(this.PrincipalSvc.getPrincipalId(), this.modulesToExport).then(
            result => {
                this.progressTitle = this.$translate.instant(this.title);
                this.displayProgress = true;
                this.taskId = result;
            },
            error => {
                this.logger.error(error.data.message);
                this.manageDisplay('form');
            }
        );
    }

    manageDisplay(step, type) {
        switch (step) {
            case 'form':
                this.displayForm = true;
                this.displayLoad = false;
                this.displayResult = false;
                break;
            case 'load':
                this.displayForm = false;
                this.displayLoad = true;
                this.displayResult = false;
                break;
            case 'result':
                this.title = 'principal.' + type + '.result.title';
                this.displayForm = false;
                this.displayLoad = false;
                this.displayResult = true;
                break;
        }
    }

    getStagedFileName(fileHeaderId) {
        const { apiContext, apiBaseUrl } = this.CONF;
        return apiContext + apiBaseUrl + '/v1/staged-files/' + fileHeaderId;
    }

    onTaskEnd(results) {
        this.displayProgress = false;
        if (results) {
            this.manageDisplay('result', this.type);

            const { result } = results;
            this.filePath = this.getStagedFileName(result);
            window.open(this.filePath, '_self');
        }
    }
}

angular.module('app.principal').component('principalExportConfig', {
    templateUrl: require('./principal-export-config.html'),
    controller: principalExportConfigCtrl,
    bindings: {
        principal: '<',
        type: '<',
    },
});
